import TippableCheckbox from './TippableCheckbox';

export default TippableCheckbox;
